import {indexBy} from 'ramda';

import {
  useGetCustomFieldsPayloadQuery,
  useGetFieldDefinitionListQuery,
  useUpdateCustomFieldsPayloadMutation,
} from '@dms/api/settings';
import {EntityResourceIds} from '@dms/api/shared';

export const useCloneCustomFields = (originalVehicleId: string) => {
  const [updatePayload] = useUpdateCustomFieldsPayloadMutation();

  const {
    data: vehicleCustomFields,
    isLoading: isLoadingVehicleCustomFields,
    isError: isErrorVehicleCustomFields,
  } = useGetCustomFieldsPayloadQuery({
    recordId: originalVehicleId,
    resourceId: EntityResourceIds.vehicle,
  });

  const {data: definitions} = useGetFieldDefinitionListQuery({
    type: 'tenant',
    resourceId: EntityResourceIds.vehicle,
  });
  const definitionsById = indexBy((item) => item.id, definitions ?? []);

  const existingVehicleFields = vehicleCustomFields?.filter((field) => {
    const definition = definitionsById[field.definitionId];
    const isCorrectType = definition?.valueType === field.value.type;

    return isCorrectType;
  });

  const cloneCustomFields = async (newVehicleId: string) => {
    await updatePayload({
      recordId: newVehicleId,
      resourceId: EntityResourceIds.vehicle,
      fieldValues: existingVehicleFields ?? [],
    });
    return newVehicleId;
  };

  return [
    cloneCustomFields,
    {isLoading: isLoadingVehicleCustomFields, isError: isErrorVehicleCustomFields},
  ] as const;
};
